/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Year_CapturedInputs */

const en_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year Captured`)
};

const es_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Año de captura`)
};

const fr_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Année de capture`)
};

const de_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahmejahr`)
};

const ja_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影年`)
};

const zh_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄年份`)
};

const ar_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنة الالتقاط`)
};

const id_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahun Diambil`)
};

const it_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anno dello Scatto/Ripresa`)
};

const ru_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Год съемки/создания`)
};

const pt_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano de Captura`)
};

const ko_field_year_captured = /** @type {(inputs: Field_Year_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`촬영 연도`)
};

/**
* | output |
* | --- |
* | "Year Captured" |
*
* @param {Field_Year_CapturedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_year_captured = /** @type {((inputs?: Field_Year_CapturedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Year_CapturedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_year_captured(inputs)
	if (locale === "es") return es_field_year_captured(inputs)
	if (locale === "fr") return fr_field_year_captured(inputs)
	if (locale === "de") return de_field_year_captured(inputs)
	if (locale === "ja") return ja_field_year_captured(inputs)
	if (locale === "zh") return zh_field_year_captured(inputs)
	if (locale === "ar") return ar_field_year_captured(inputs)
	if (locale === "id") return id_field_year_captured(inputs)
	if (locale === "it") return it_field_year_captured(inputs)
	if (locale === "ru") return ru_field_year_captured(inputs)
	if (locale === "pt") return pt_field_year_captured(inputs)
	return ko_field_year_captured(inputs)
});